import { gql, useQuery } from "@apollo/client";
import type { IMetaobjectByHandleQuery } from "@repo/shopify/queries/metaobject-gql";
import { metaobjectByHandleQuery } from "@repo/shopify/queries/metaobject-gql";
import type { MetaobjectField } from "@shopify/hydrogen-react/storefront-api-types";
import React, { useEffect } from "react";
import { useParams } from "react-router-dom";

import Link from "@atoms/Link";
import Loading from "@atoms/Loading";

import { DEFAULT_TITLE } from "@const/meta";
import { NOTIFICATIONS } from "@const/notifications";

import { useLayoutStore } from "@store/layout";

export default function RecruitDetail() {
  const { handle } = useParams();

  const { openToast, setMeta } = useLayoutStore();

  const { data, loading } = useQuery<IMetaobjectByHandleQuery>(gql(metaobjectByHandleQuery.query), {
    variables: { handle: { handle, type: "recruit" } },
    fetchPolicy: "no-cache",
    onCompleted: (_data) => {
      const title = _data?.metaobject.fields.find((item) => item.key === "title");
      setMeta({ title: `${title?.value?.replace(/\\n/g, " ")} - ${DEFAULT_TITLE}` });
    },
    onError: (error) => {
      openToast(NOTIFICATIONS.ERROR_SERVER);
      throw new Error(error.message);
    },
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [handle]);

  const getValue = (fields: MetaobjectField[] | undefined, key: string) => {
    return fields?.find((item) => item.key === key);
  };

  const detailFields = getValue(data?.metaobject?.fields, "detail_fields")?.references?.edges;

  return (
    <>
      {loading || !data ? (
        <Loading type="page" />
      ) : (
        <>
          <section className="pc:col-span-10 col-span-8 flex justify-between">
            <div className="text-title flex flex-col whitespace-pre-line">
              {getValue(data.metaobject.fields, "title")?.value?.replace(/\\n/g, "\n")}
            </div>
            <Link
              as="text"
              href={`mailto:${getValue(data.metaobject.fields, "inquiry_mail")?.value}?cc=jp@thisisneverthat.com`}
            >
              Apply Job
            </Link>
          </section>
          <section className="pc:col-span-10 col-span-8 row-start-3 flex flex-col gap-10">
            <section className="pc:col-span-10 col-span-8 row-start-3 flex flex-col gap-1">
              {detailFields?.map((edge) => {
                if (edge?.node?.__typename !== "Metaobject") return null;

                const title = edge.node.fields.find((field) => field.key === "title")?.value || "";
                const description = edge.node.fields.find((field) => field.key === "description")?.value || "";

                return (
                  <div className="tnt-gap-x pc:gap-y-1 pc:grid pc:grid-cols-12 flex flex-col gap-2" key={edge.node.id}>
                    <span className="pc:col-span-1 col-span-2">{title}</span>
                    <p className="pc:col-span-11 col-span-4 block break-all whitespace-pre-wrap">{description}</p>
                  </div>
                );
              })}
            </section>
          </section>
        </>
      )}
    </>
  );
}
